import { IconButton } from '@xo-union/tk-component-icons';
import React from 'react';

import styles from './addressDisplay.scss';

interface Props {
  editCallback?: Function;
  deleteCallback?: Function;
  vendorType?: string | null;
  name?: string | null;
  street1?: string | null;
  street2?: string | null;
  zip?: string | null;
  city?: string | null;
  state?: string | null;
  country?: string | null;
}

export const AddressDisplay: React.FC<Props> = props => {
  const {
    vendorType = 'Vendor',
    name = '',
    street1 = '',
    street2 = '',
    city = '',
    state = '',
    country = '',
    zip = '',
    deleteCallback,
    editCallback,
  } = props;
  const cityStateZip = [city, state, zip].filter(Boolean).join(', ');

  return (
    <div className={styles.container}>
      <div className={styles.fakeLabel}> {vendorType} </div>
      <div className={styles.wrapper}>
        <div className={styles.vendorDetails}>
          {name && <div className={styles.vendorName}> {name} </div>}
          {street1 && <div> {street1} </div>}
          {street2 && <div> {street2} </div>}
          {cityStateZip && <div> {cityStateZip} </div>}
          {country && <div> {country} </div>}
        </div>
        <div className={styles.buttonContainer}>
          {editCallback && (
            <IconButton
              aria-label="Edit address"
              // @ts-ignore
              type="button"
              className={styles.icon}
              name="edit"
              size="md"
              // @ts-ignore
              onClick={(e): void => editCallback(e)}
            />
          )}
          {deleteCallback && (
            <IconButton
              aria-label="Delete address"
              // @ts-ignore
              type="button"
              className={styles.icon}
              name="delete"
              size="md"
              // @ts-ignore
              onClick={(e): void => deleteCallback(e)}
            />
          )}
        </div>
      </div>
    </div>
  );
};
